import { render, staticRenderFns } from "./StaticInfo.vue?vue&type=template&id=9f87b5bc&scoped=true"
import script from "./StaticInfo.vue?vue&type=script&lang=js"
export * from "./StaticInfo.vue?vue&type=script&lang=js"
import style0 from "./StaticInfo.vue?vue&type=style&index=0&id=9f87b5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f87b5bc",
  null
  
)

export default component.exports